module.exports = __webpack_public_path__ + "5ad8d59a6bd02fdffc555b003277e804.ico";